import { Component } from 'react';

import { type ErrorBoundaryProps } from '../../ErrorBoundary.types';

class SilentErrorBoundary extends Component<ErrorBoundaryProps, SilentErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {};
  }

  static getDerivedStateFromError(error: Error): SilentErrorBoundaryState {
    return { error };
  }

  render() {
    return this.state.error ? this.props.fallback({ error: this.state.error }) : this.props.children;
  }
}

type SilentErrorBoundaryState = {
  error?: Error;
};

export default SilentErrorBoundary;
